import "core-js/modules/web.timers";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React, { useContext, useEffect } from 'react';
import Block from 'wfui-digital-core/es/Block';
import Button from 'wfui-digital-core/es/Button';
import StickyFooterContext from '../../../context/StickyFooterContext';
import BackIcon from '../../../icons/back/BackIcon';
import CloseIcon from '../../../icons/close/CloseIcon';
import styles from './Header.less';

var Header = function Header() {
  var _useContext = useContext(StickyFooterContext),
      menuOpen = _useContext.menuOpen,
      closeMenu = _useContext.closeMenu,
      headingId = _useContext.headingId,
      getString = _useContext.getString,
      secondaryMenu = _useContext.secondaryMenu,
      setSecondaryMenu = _useContext.setSecondaryMenu,
      headerContent = _useContext.headerContent,
      headingRef = _useContext.headingRef; // Set focus on header when menu opens


  useEffect(function () {
    if (menuOpen) {
      setTimeout(function () {
        var accessibilityFocus = document.getElementById('accessibilityFocus');
        accessibilityFocus && accessibilityFocus.focus();
        setTimeout(function () {
          headingRef.current && headingRef.current.focus();
        }, 600);
      }, 100);
    }
  }, [headingRef, menuOpen]); // Set focus on header when secondary menu opens

  useEffect(function () {
    if (menuOpen && secondaryMenu) {
      setTimeout(function () {
        var accessibilityFocus = document.getElementById('accessibilityFocus');
        accessibilityFocus && accessibilityFocus.focus();
        setTimeout(function () {
          headingRef.current && headingRef.current.focus();
        }, 600);
      }, 100);
    }
  }, [headingRef, menuOpen, secondaryMenu]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Block, {
    layout: true,
    horizontal: true,
    centered: true,
    id: headingId,
    role: "heading",
    "aria-level": "1",
    tabIndex: "-1",
    className: styles.header,
    elementRef: headingRef,
    "data-testid": "menuHeading"
  }, headerContent), secondaryMenu && /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return setSecondaryMenu(null);
    },
    className: styles.backButton,
    "aria-label": getString('global.back')
  }, /*#__PURE__*/React.createElement(BackIcon, {
    decorative: true
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: closeMenu,
    className: styles.closeButton,
    "aria-label": getString('global.close')
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    decorative: true
  })));
};

export default Header;